// removed by extract-text-webpack-plugin
module.exports = {"electro":"aLSkVTM70gFkANkCE1WY7","tg":"_1fq8-sC2iZE285E69dJEF6","title":"rRnDJm_vpDruQrmJV-xMi","subtitle":"_2C8srei8BMuiNUCEd4Wy_F","value":"_10qmgVIYfSTfSA0ssGxsXq","disabled":"_1V2Lm17OVGy4oJIkOh9Id_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/ElectroCell/style.css
// module id = 337
// module chunks = 0